import * as React from 'react';
import { Stack } from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { TeachingBubble } from '@fluentui/react/lib/TeachingBubble';

export const Button = ({ action, loading, disabled, headline, text }) => {
  const buttonId = useId('targetButton');
  const [teachingBubbleVisible, { toggle: toggleTeachingBubbleVisible }] = useBoolean(false);

  const SecondaryButtonProps = React.useMemo(
    () => ({
      children: 'Não',
      onClick: toggleTeachingBubbleVisible,
    }),
    [toggleTeachingBubbleVisible],
  );

  const handleButtonText = () => {
    if (loading) return 'Salvando...';
    return text;
  }

  const handleAction = () => {
    action();
  }

  return (
    <Stack>
      <DefaultButton
        id={buttonId}
        disabled={disabled}
        onClick={toggleTeachingBubbleVisible}
        loading={loading}
        text={handleButtonText()}
      />
      {teachingBubbleVisible && (
        <TeachingBubble
          target={`#${buttonId}`}
          primaryButtonProps={{
            children: 'Sim',
            onClick: () => {
              handleAction();
              toggleTeachingBubbleVisible();
            },
          }}
          secondaryButtonProps={SecondaryButtonProps}
          onDismiss={toggleTeachingBubbleVisible}
          headline={headline}
        > 
        </TeachingBubble>
      )}
    </Stack>
  );
};

export default  Button;

